import { Component, Input, OnInit } from '@angular/core';
import { MatDialogConfig } from '@angular/material/dialog';
import { BooleanCons, StringConst } from 'src/app/constants/const';
import { DisplayVideoComponent } from 'src/app/dialogs/display-video/display-video.component';
import { DialogService } from 'src/app/services/dialog.service';

@Component({
  selector: 'app-youtube-player',
  templateUrl: './youtube-player.component.html',
  styleUrls: ['./youtube-player.component.scss']
})
export class YoutubePlayerComponent implements OnInit {
  apiLoaded = false;
  @Input() videoId = StringConst.empty;
  @Input() clickToOpenInDialog = BooleanCons.false;
  playerVar = {
    origin: window.location.href,
    host: 'https://www.youtube.com',
  };
  constructor(private dialogService: DialogService) { }

  ngOnInit(): void {
    if (!document.getElementById('youtube-tag-player')) {
      const tag = document.createElement('script');
      tag.id = 'youtube-tag-player';
      tag.src = 'https://www.youtube.com/iframe_api';
      document.body.appendChild(tag);
    }
  }

  openDialog(): void {
    const config = new MatDialogConfig();
    config.data = this.videoId;
    this.dialogService.displayDialog(DisplayVideoComponent, config);
  }

}
